module.exports = __webpack_public_path__ + "img/violet_021.7572025e.png";